import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["wrapper", "children"],
    _excluded2 = ["children"];
import React from 'react';
import createReactContext from 'create-react-context';
import PropTypes from 'prop-types';
export var createContext = React.createContext || createReactContext;
export function createWrapContext() {
  var WrapContext = createContext(false);

  function Provider(_ref) {
    var Wrapper = _ref.wrapper,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/React.createElement(WrapContext.Consumer, null, function (wrapped) {
      return wrapped ? children : /*#__PURE__*/React.createElement(WrapContext.Provider, {
        value: true
      }, /*#__PURE__*/React.createElement(Wrapper, props, children));
    });
  }

  Provider.propTypes = {
    wrapper: PropTypes.func.isRequired,
    children: PropTypes.node
  };
  Provider.defaultProps = {
    children: null
  };

  function StandAlone(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/React.createElement(WrapContext.Provider, {
      value: false
    }, children);
  }

  StandAlone.propTypes = {
    children: PropTypes.node
  };
  StandAlone.defaultProps = {
    children: null
  };
  return {
    StandAlone: StandAlone,
    Provider: Provider,
    WrapperComponent: function WrapperComponent(Wrapper) {
      function WrapperProvider(_ref3) {
        var children = _ref3.children,
            props = _objectWithoutProperties(_ref3, _excluded2);

        return /*#__PURE__*/React.createElement(Provider, _extends({
          wrapper: Wrapper
        }, props), children);
      }

      WrapperProvider.propTypes = {
        children: PropTypes.node
      };
      WrapperProvider.defaultProps = {
        children: null
      };
      return WrapperProvider;
    }
  };
}